import { Component, Input } from '@angular/core';
import { ContainerComponent } from '../../container/container.component';
import { RouterLink } from '@angular/router';
import { RegulatoryPraModel } from '../../../../models/regulatory-pra.model';
import { ProjectStatusComponent } from '../../project-status/project-status.component';

@Component({
  selector: 'app-regulatory-acts-list',
  imports: [ContainerComponent, RouterLink, ProjectStatusComponent],
  templateUrl: './regulatory-acts-list.component.html',
  standalone: true,
  styleUrl: './regulatory-acts-list.component.scss',
})
export class RegulatoryActsListComponent {
  @Input() praList: RegulatoryPraModel[] = [];
}
